import { z } from 'zod'

import {
  CustomerChatMessageDirection,
  CustomerChatMessageEvent,
  CustomerChatMessageState,
  CustomerChatMessageType,
  CustomerChatMessageVisibility,
} from '../constants/customerChatMessage'
import { dbEntitySchema } from './system'

export const customerChatMessageSchema = dbEntitySchema.extend({
  createdDiary: z.string().nullish(),
  organization: z.string(),
  venue: z.string(),
  customer: z.string(),
  type: z.nativeEnum(CustomerChatMessageType).nullish(),
  state: z.nativeEnum(CustomerChatMessageState).nullish(),
  visibility: z.nativeEnum(CustomerChatMessageVisibility),
  eventType: z.nativeEnum(CustomerChatMessageEvent).nullish(),
  messageDirection: z
    .nativeEnum(CustomerChatMessageDirection)
    .optional()
    .nullable(),
  fromNumber: z.string().nullish(),
  fromEmail: z.string().email().nullish(),
  fromOrganizationMember: z.string().nullish(),
  toNumber: z.string().nullish(),
  toEmail: z.string().email().nullish(),
  text: z.string().min(1),
  imageUrl: z.string().nullish(),
  data: z.record(z.any()).nullish(),
  fromOrganizationMemberName: z.string().nullish(),
  fromOrganizationMemberInitials: z.string().nullish(),
  fromSystem: z.boolean().nullish(),
})

export const customerChatMessageCreateArgsSchema = customerChatMessageSchema
  .omit({
    id: true,
    _id: true,
    deleted: true,
    created: true,
    modified: true,
    fromOrganizationMember: true,
    fromOrganizationMemberName: true,
    fromOrganizationMemberInitials: true,
    fromSystem: true,
    organization: true,
    venue: true,
    customer: true,
    state: true,
    visibility: true,
  })
  .extend({
    customerId: z.string(),
    venueId: z.string(),
    sendPubSubEvents: z.boolean().nullish(),
    fromOrganizationMemberId: z.string().nullish(),
    visibility: z.nativeEnum(CustomerChatMessageVisibility).nullish(),
    state: z.nativeEnum(CustomerChatMessageState).nullish(),
  })

export const customerChatMessageListArgsSchema = z.object({
  venueId: z.string(),
  customerId: z.string(),
  visibility: z.nativeEnum(CustomerChatMessageVisibility).nullish(),
  type: z
    .nativeEnum(CustomerChatMessageType)
    .or(z.array(z.nativeEnum(CustomerChatMessageType)))
    .optional()
    .nullable(),
  organizationId: z.string().nullish(),
})
